import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=f7faffce&scoped=true&"
import script from "./BaseLabel.vue?vue&type=script&lang=js&"
export * from "./BaseLabel.vue?vue&type=script&lang=js&"
import style0 from "./BaseLabel.vue?vue&type=style&index=0&id=f7faffce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7faffce",
  null
  
)

export default component.exports